import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  width: 1100px;
  margin: 100px 0;
  justify-content: space-between;
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const ColumnFocusNode = styled(FocusNode)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const HeaderElement = styled.div`
  position: relative;
  padding-top: 60px;
  padding-bottom: 20px;
`
export const Title = styled.h3`
  font-size: 30px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.account.title};
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 24px;
  text-align: left;
`
export const Description = styled.p`
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 20px;
  text-align: left;
  max-width: 700px;
  color: ${(props) => props.theme.colors.account.text};
`
export const RegisterWrapper = styled('div')`
  position: relative;
  width: 650px;
  border-top: 4px solid ${(props) => props.theme.colors.account.separator};
  margin-top: 60px;
  padding-top: 40px;
`
export const MobileAppImg = styled.img`
  object-fit: cover;
`
export const MobileAppImgWrapperAccount = styled('div')`
  height: 542px;
  width: 288px;
  flex: 0 0 288px;
`
